/**
 * The two button shapes from `faithfully-kept-business/design/home/`, and the text link, as class
 * lists in the website's tokens. A 56px navy button for the action that matters, a 56px outlined one
 * beside it, the same outlined one at 48px inside a card, as Schedule's "Skip or move" is drawn,
 * and a link that is still a box at least 48px tall, standing alone or inside a sentence.
 */
export const NAVY_BUTTON =
  'flex min-h-tap-call w-full items-center justify-center rounded-control bg-surface-brand px-6 ' +
  'text-body font-semibold text-text-on-brand hover:bg-surface-brand-strong';

export const GHOST_BUTTON =
  'flex min-h-tap-call w-full items-center justify-center rounded-control border-2 ' +
  'border-border-brand px-6 text-body font-semibold text-text-brand hover:bg-surface-accent-soft';

export const CARD_BUTTON =
  'flex min-h-tap w-full items-center justify-center rounded-control border-2 ' +
  'border-border-brand px-6 text-body font-semibold text-text-brand hover:bg-surface-accent-soft';

export const TEXT_LINK =
  'inline-flex min-h-tap items-center text-text-brand underline underline-offset-4 ' +
  'hover:text-text-body';

/**
 * The text link inside a sentence, which the artboards draw as a plain underlined word in its line.
 *
 * - IT IS STILL A BOX AT LEAST 48 TALL to take a thumb, as `TEXT_LINK` is, and 24px wider than its
 *   words, 12px each side.
 * - IT IS LAID OUT AS A PLAIN WORD: margins of -12px on every side, with 12px of padding at the
 *   sides, take back all it adds, so its line is no taller than the rest of the sentence (24px laid
 *   out, less than any line these screens set, small type at 1.55 and up) and its words do not move.
 *   The box reaches over the lines beside it to take the tap.
 * - ITS RING IS DRAWN 10PX INSIDE THE BOX, 2px clear of its words, instead of around a box that
 *   reaches over the lines beside it. The ring utility is important because the page's ring in
 *   `styles.css` sits outside Tailwind's layers and would otherwise win, as `BottomNav`'s `TAB` says.
 * - WHAT FOLLOWS IT WITH NO SPACE, A FULL STOP AS A RULE, SITS WITH IT IN ONE SPAN THAT DOES NOT
 *   WRAP, as `Phone.tsx` draws the office's number, because Chrome may break a line between a link
 *   laid out as one box and the punctuation after it (`api/test/links.test.ts`).
 */
export const INLINE_LINK = `${TEXT_LINK} -m-3 px-3 focus-visible:-outline-offset-10!`;

/**
 * The navy button for words that may take two lines on a phone, as Settings-Paying draws "Pay it
 * from your bank account": centred, at a line height of 1.2 and 20px at the sides, as the artboard
 * draws it, so two lines still sit inside the 56px box, rather than `NAVY_BUTTON`'s body line height,
 * which would leave a second line hanging left and the box taller.
 */
export const NAVY_BUTTON_WRAPPING =
  'flex min-h-tap-call w-full items-center justify-center rounded-control bg-surface-brand px-5 ' +
  'py-1 text-center text-body/[1.2] font-semibold text-pretty text-text-on-brand ' +
  'hover:bg-surface-brand-strong';
